import { defineStore } from "pinia";

const createToast = (title, subtitle, theme, position, icon) => ({
  title,
  subtitle,
  theme,
  position,
  icon,
  id: Math.random() * 1000,
  progress: 0,
  progressInterval: null,
});
export const toastStore = defineStore("toast", {
  state: () => ({
    toasts: [],
  }),
  getters: {},
  actions: {
    setError(error) {
      this.errors = { ...error };
    },
    updateState(payload, theme) {
      const { title, subtitle, position, icon } = payload;

      const toast = createToast(title, subtitle, theme, position, icon);

      this.toasts.push(toast);
    },
    success(payload) {
      this.updateState(payload, "success");
    },
    warning(payload) {
      this.updateState(payload, "warning");
    },
    error(payload) {
      this.updateState(payload, "error");
    },
    removeToast(id) {
      this.toasts = this.toasts.filter((t) => t.id !== id);
    },
    updateProgress(id, progressIncrement) {
      const toast = this.toasts.find((t) => t.id === id);
      if (toast) {
        toast.progress += progressIncrement;
      }
    },
  },
});
